import { useState, useEffect, useRef } from "react";
const stripHtml = (html) => {
	if(!html) return "";
	const div = document.createElement("div");
	div.innerHTML = html;
	return (div.textContent || "").trim();
};

const getPageLabel = (page, index) => {
	const sE = page.elements.find((e) => e.type === "multipleChoice");
	const sT = !sE && page.elements.find((e) => e.type === "text");
	const text = stripHtml(sE?.question || sT?.html || "");
	const truncated = text.length > 40 ? text.slice(0, 40) + "…" : text;
	return `Page ${index + 1}${truncated ? ": " + truncated : ""}`;
};

function PageSelectDropdown({ label, pages, selectedId, onSelect }){
	const [open, setOpen] = useState(false);
	const ref = useRef(null);

	useEffect(() => {
		if(!open) return;
		const handleClick = (e) => {
			if(ref.current && !ref.current.contains(e.target)) setOpen(false);
		};
		document.addEventListener('mousedown', handleClick);
		return () => document.removeEventListener('mousedown', handleClick);
	}, [open]);

	const selectedIndex = pages.findIndex((p) => p.id === selectedId);
	const selectedPage = selectedIndex >= 0 ? pages[selectedIndex] : null;
	const selectedLabel = selectedPage ? getPageLabel(selectedPage, selectedIndex) : "Not set";

	return (
		<div className={`dropdown ${open ? 'active' : ''}`} ref={ref}>
			<button type="button" className="btn btn-secondary btn-100" onClick={() => setOpen(!open)}>
				<span className="text--muted mright--5">{label}:</span>
				<b>{selectedLabel}</b>
			</button>
			<div className="dropdown__menu">
				<div className="dropdown__content">
					{selectedId && (
						<div className="dropdown__item" onClick={() => { onSelect(null); setOpen(false); }}>
							<em className="text--muted">Clear selection</em>
						</div>
					)}
					{pages.map((page, i) => (
						<div
							key={page.id}
							className={`dropdown__item ${page.id === selectedId ? 'dropdown__item-active' : ''}`}
							onClick={() => { onSelect(page.id); setOpen(false); }}
						>
							{getPageLabel(page, i)}
						</div>
					))}
				</div>
			</div>
		</div>
	);
}

export default PageSelectDropdown;
